import { ReactElement, useEffect } from 'react';

import GratiPageWrapper from '../components/common/GratiPageWrapper';
import OrgVanityUrlRequestDirectory from '../components/orgVanityUrlRequests/OrgVanityUrlRequestDirectory';
import { useApp } from '../contextProviders/AppProvider';
import useOrgVanityUrlRequests from '../dataHooks/useOrgVanityUrlRequests';

export default function OrgVanityUrlRequestsPage(): ReactElement {
  const { setPageName } = useApp();
  const { requests, isLoading, error } = useOrgVanityUrlRequests();

  useEffect(() => {
    setPageName('Vanity URL Requests');
  }, [setPageName]);

  return (
    <GratiPageWrapper>
      <OrgVanityUrlRequestDirectory
        pageTitle="Vanity URL Requests"
        requests={requests || undefined}
        isLoading={isLoading}
        error={error}
      />
    </GratiPageWrapper>
  );
}
